import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Layer } from 'bernie-view';
import { AnalyticsStore, DialogRoute, RouteStore } from 'bernie-core';
import { DialogsStore, SearchFormStore } from 'stores';
import { setDateField, trackAnalytics } from 'utility';
import { DialogForcedChoiceLodgingCrossSell } from 'types/search/dialogs';
import { ForcedChoiceModalDialog } from '.';
import { ActionType, AnalyticsType } from 'types/shared';
import { FlightsActionType } from '__generated__/api';

export interface ForcedChoiceModalProps {
  dialogForcedChoiceLodgingCrossSell: DialogForcedChoiceLodgingCrossSell;
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  searchFormStore?: SearchFormStore;
  dialogsStore?: DialogsStore;
  handleActionSelection?: (actionType: FlightsActionType) => void;
}

export const FORCED_CHOICE_DIALOG_ID = 'forced-choice-modal';

@inject('routeStore', 'analytics', 'searchFormStore', 'dialogsStore')
@observer
export class ForcedChoiceModal extends React.Component<ForcedChoiceModalProps> {
  public componentDidMount = () => {
    this.openDialog();
  };

  private closeAndValidateDialog = (flightsActionType: FlightsActionType, e) => {
    const { routeStore, dialogsStore, analytics, handleActionSelection } = this.props;

    if (flightsActionType === FlightsActionType.GO_TO_PACKAGES) {
      const valid = dialogsStore.validateForcedChoiceModal(analytics);
      if (!valid) {
        e.preventDefault();

        return;
      }
      this.decodeEncodePackageAbleUrl();
    }
    dialogsStore.resetForcedChoiceModelErrors();
    handleActionSelection(flightsActionType);
    document.documentElement.classList.remove('block-scroll');
    routeStore.goBack();
  };

  private decodeEncodePackageAbleUrl = () => {
    const {
      dialogForcedChoiceLodgingCrossSell: { checkInDate, checkOutDate, actions }
    } = this.props;
    if (checkInDate && checkInDate.date && checkOutDate && checkOutDate.date) {
      const actionType =
        actions && (actions.find(action => action.type === FlightsActionType.GO_TO_PACKAGES) as ActionType);
      let decodedUrl =
        actionType &&
        actionType.relativePackageableURI &&
        actionType.relativePackageableURI.relativePath &&
        decodeURIComponent(actionType.relativePackageableURI.relativePath);
      decodedUrl =
        decodedUrl &&
        decodedUrl
          .replace('${checkInDate}', checkInDate.date.isoFormat)
          .replace('${checkOutDate}', checkOutDate.date.isoFormat)
          .replace('${toDate}', checkOutDate.date.isoFormat);
      actionType.relativePackageableURI = { relativePath: decodedUrl && encodeURI(decodedUrl), value: null };
    }
  };

  public openDialog = () => {
    const { routeStore, analytics, dialogForcedChoiceLodgingCrossSell } = this.props;
    const dialogQuery = routeStore.mergeQueryString(routeStore.search, { pwaDialog: FORCED_CHOICE_DIALOG_ID });
    const analyticsType: AnalyticsType =
      dialogForcedChoiceLodgingCrossSell && dialogForcedChoiceLodgingCrossSell.displayedAnalytics;
    trackAnalytics(analyticsType, analytics);
    routeStore.updateSearch(dialogQuery);
    document.documentElement.classList.add('block-scroll');
  };

  private updateHotelDates = (selectedCheckInDate: Date, selectedCheckOutDate?: Date): void => {
    const { dialogForcedChoiceLodgingCrossSell } = this.props;
    setDateField(dialogForcedChoiceLodgingCrossSell.checkInDate, selectedCheckInDate);

    if (selectedCheckOutDate) {
      setDateField(dialogForcedChoiceLodgingCrossSell.checkOutDate, selectedCheckOutDate);
    } else {
      dialogForcedChoiceLodgingCrossSell.checkOutDate.date = null;
    }
  };

  public render() {
    const { dialogsStore } = this.props;
    const defaultCheckInDate =
      dialogsStore.getInitialForcedChoiceModalDialog() && dialogsStore.getInitialForcedChoiceModalDialog().checkInDate;

    return (
      <DialogRoute id={FORCED_CHOICE_DIALOG_ID}>
        <Layer id={`${FORCED_CHOICE_DIALOG_ID}-dialog`}>
          <ForcedChoiceModalDialog
            dialogId={FORCED_CHOICE_DIALOG_ID}
            handleActionSelection={this.closeAndValidateDialog}
            {...this.props.dialogForcedChoiceLodgingCrossSell}
            flightType={this.props.searchFormStore.selectedTripTypeOptionItem.tripType}
            updateHotelDates={this.updateHotelDates as () => void}
            defaultCheckInDate={defaultCheckInDate}
          />
        </Layer>
      </DialogRoute>
    );
  }
}
